import { Observable } from "rxjs";
import { NotificationService } from "./notification.service";
import { Injectable } from "@angular/core";
import { ConfirmationService, ConfirmationConfig } from "@mtm/conversation-ui-angular";

@Injectable()
export class NotificationConfirmationAdapter extends ConfirmationService {
    constructor(private notificationService: NotificationService) {
        super();
    }

    open(config: ConfirmationConfig): Observable<boolean> {
        return this.notificationService.open(config);
    }
}   